import * as swcHelpers from '@swc/helpers';
import React__default from 'react';

const ReactDatePicker = (_param)=>{
    var { locale , dateFnsLocale  } = _param, props = swcHelpers.objectWithoutProperties(_param, [
        "locale",
        "dateFnsLocale"
    ]);
    const [Module, setModule] = React__default.useState(null);
    const loadComponent = React__default.useCallback(swcHelpers.asyncToGenerator(function*() {
        const importedModule = yield import(/* webpackChunkName: 'react-datepicker' */ 'react-datepicker');
        const { registerLocale  } = importedModule;
        registerLocale(locale, dateFnsLocale);
        setModule(importedModule);
    }), [
        locale,
        dateFnsLocale
    ]);
    React__default.useEffect(()=>{
        loadComponent();
    }, [
        loadComponent
    ]);
    // Don't render if we didn't register the (date-fns)locale correctly
    // as we're not able to translate days/months without it
    return Module && /*#__PURE__*/ React__default.createElement(Module.default, swcHelpers.extends({
        locale: locale
    }, props));
};
var ReactDatePicker$1 = ReactDatePicker;

export { ReactDatePicker$1 as default };
//# sourceMappingURL=ReactDatePicker.js.map
